import { API } from "./utils"


export const agents = {
  agentsList: (params=null) => API.get("/parties/agents/", { params: params }),
}